<template>
<div class='cssmessage'>
    <div  style='width: 65%;'>
        <i>{{ message }}</i>
    </div>
</div>
</template>
<script>
export default {
  name: 'LoginMessage',
  props: {
    message: String,
  },
};
</script>
<style scoped>
.cssmessage {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>
